/**
 * Front route declaration, with their associated component
 * @see {@link https://router.vuejs.org/guide/essentials/named-routes.html|Vue Router Named Route}
 */

export default [
    {
        path: '/rest/prospection/opportunities/:id/:type',
        name: 'legacy.opportunity.save'
    },
]